import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import PortalSubtopicAsideWidget from "@/apps/PortalSubtopicAsideWidget/components/PortalSubtopicAsideWidget.vue";
import Vuex from "vuex";
import {root} from "@/shared/store";
import {PortalSubtopicAsideWidgetState} from "@/apps/PortalSubtopicAsideWidget/models/PortalSubtopicAside-widget-state";
import mutations from "@/apps/PortalSubtopicAsideWidget/store/mutations";
import getters from "@/apps/PortalSubtopicAsideWidget/store/getters";
import actions from "@/apps/PortalSubtopicAsideWidget/store/actions";

Vue.config.productionTip = false
Vue.config.devtools = true;
Vue.use(VueCompositionAPI)

let widget = document.querySelectorAll('widget-portal-subtopic-aside')

if (widget.length) {
    widget.forEach(element => {

        let store = new Vuex.Store({
            state: new PortalSubtopicAsideWidgetState(),
            mutations: mutations,
            getters: getters,
            actions: actions,
            modules: {
                root
            }
        })

        new Vue({
            el: element,
            store,
            render(h: any) {
                let relatedPages = this.$el.attributes.getNamedItem('relatedPages');
                let contactInformation = this.$el.attributes.getNamedItem('contactInformation');
                let labels = this.$el.attributes.getNamedItem('labels');

                return h(PortalSubtopicAsideWidget, {
                    props: {
                        relatedPages: relatedPages ? JSON.parse(relatedPages.value) : null,
                        contactInformation: contactInformation ? JSON.parse(contactInformation.value) : null,
                        labels: labels ? JSON.parse(labels.value) : null,
                    }
                })
            }
        })
    })
}
